<af-main-container #mainContainerComponent [title]="'i18n_lib_breadcrumb#RefundId' | translate :{refundId: refund?.id || refundId}"
                   spinnerIds="initial"
                   [queryParamsHandling]="'merge'"
                   [navigateBackListener]="navigateBack"
                   [filterNavigationPath]="incidentId ? 'refunds' : ''"
                   [breadcrumbCustomizer]="breadcrumbCustomizer">
    <div CustomTitle class="w-100 mr-16 ml-16" fxLayout="row" fxLayoutAlign="space-between center" fxFlex>
        @if (refund) {
            <af-status [statusText]="statusInfo.text" [status]="statusInfo.style"/>
        }
        <div class="w-100" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
            @if (hasEditButton) {
                <ui-kit-svg class="i-24 pointer c-primary-green-800" name="ic_edit" [matTooltip]="'i18n_af_labelEdit' | translate"
                            (click)="editRefund()"/>
            }
            @if (hasDeleteButton) {
                <ui-kit-svg class="i-24 pointer c-primary-green-800" name="ic_delete" [matTooltip]="'i18n_af_labelDelete' | translate"
                            (click)="deleteRefund()"/>
            }
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
                @if (hasRejectButton) {
                    <ui-kit-button [label]="'i18n_af_buttonReject' | translate"
                                   type="secondary"
                                   color="accent"
                                   [disabled]="Spinner.isShown('createRefund') || Spinner.isShown('editRefund')"
                                   (clickListener)="openRejectDialog()"/>
                }
                @if (actionButtonLabel) {
                    <ui-kit-button [label]="actionButtonLabel | translate"
                                   [disabled]="Spinner.isShown('createRefund') || Spinner.isShown('editRefund')"
                                   (clickListener)="changeRefundStatus()"/>
                }
            </div>
        </div>
    </div>
    <div class="w-100 h-100" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="16px" fxFlex>
        @if (refund) {
            @if (refund.rejectedBin) {
                <af-refund-reject-panel class="w-100 mt-24" [refund]="refund"/>
            }
            <mat-tab-group mat-align-tabs="start" animationDuration="0"
                           class="w-100 h-100 overflow-y-scroll"
                           [(selectedIndex)]="selectedTabIndex"
                           (selectedIndexChange)="handleNavigation($event)">
                @for (tab of tabs; track tab) {
                    <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                        <ng-template matTabContent>
                            @if (tab === 'tabRefundDetails') {
                                <af-refund-details-tab [refund]="refund"
                                                       class="mt-24 w-100 h-fit-content"
                                                       fxFlex/>
                            }
                            @if (tab === 'tabOrder') {
                                <af-refund-approval-tab [refund]="refund"
                                                        class="mt-24 w-100 h-fit-content"
                                                        fxFlex/>
                            }
                            @if (tab === 'tabHistory') {
                                <af-entity-history [entityId]="refundId" [entityType]="EntityType.REFUND" mode="full"/>
                            }
                        </ng-template>
                    </mat-tab>
                }
            </mat-tab-group>
        }
    </div>
</af-main-container>
